import request from '@/utils/request'

/**
 * 积分兑换订单核销相关接口
 * 后端 Controller: PointsOrderController
 * 基础路径: /points/user/order
 */

/**
 * 核销（店员端扫码 + 确认数量 → 置为已核销，支持部分核销）
 * @param {String} verifyCode 核销码
 * @param {Number} quantity   本次核销数量（默认 1）
 */
export function verifyByCode(verifyCode, quantity = 1) {
  return request({
    url: '/points/user/order/verify/scan',
    method: 'post',
    params: { verifyCode, quantity }
  })
}

/**
 * 核销信息（核销码 + 有效期 + 状态 + 商品快照 + 已核销数量）
 * @param {Object|String} params { verifyCode } 或直接传 verifyCode 字符串
 */
export function getVerifyInfo(params) {
  const query = (typeof params === 'object') ? params : { verifyCode: params }
  return request({
    url: '/points/user/order/verify/info',
    method: 'get',
    params: query
  })
}

/** 查询是否允许核销 */
export function allowWriteOff() {
  return request({
    url: '/points/user/order/allow/writeoff',
    method: 'post'
  })
}
